import { required } from 'ra-core';
import { AutocompleteInput } from '../../components/admin/autocomplete-input';
import { ReferenceInput } from '../../components/admin/reference-input';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { SimpleStack } from '../Moonstar/SimpleStack';

export const TopicCreate = () => (
  <MoonstarCreate redirect="list">
    <MoonstarCreateForm>
      <SimpleStack>
        <TextInput source="displayName" validate={required()} />
        <ReferenceInput
          source="formTypeId"
          sort={{ field: 'id', order: 'ASC' }}
          reference="formTypes"
        >
          <AutocompleteInput
            optionText="typeName"
            validate={required()}
            filterToQuery={(searchText) => ({ typeName: searchText })}
          />
        </ReferenceInput>
      </SimpleStack>
    </MoonstarCreateForm>
  </MoonstarCreate>
);
